import { Outlet, useLoaderData } from 'react-router'
import Header from '../components/Header'
import { InfoProvider } from '../context/useInfo'

function Layout() {
    const info = useLoaderData();

    return <InfoProvider preloadedInfo={info}>
        <Header />
        <main className='bg-foreground m-auto max-w-4xl rounded-lg sm:rounded-t-lg min-h-minimal p-4 overflow-hidden sm:mt-0 mt-2 phones:mb-28'>
            <Outlet />
        </main>
    </InfoProvider>
}

export default Layout